export default __webpack_public_path__ + "static/okr-hero-eeee2c3461154f58b396e12a6ae088bb.webm";